import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API, recordLaunch } from "../lib/api";
import { outboundHref } from "../lib/utils-tv";

// Labelled sponsored rows (max 3) above a hub / alternatives list. Renders
// nothing when the `sponsored` flag is off or no slot is sold for this page.
export default function SponsoredSlots({ placement }) {
  const [slots, setSlots] = useState([]);
  useEffect(() => {
    let live = true;
    axios
      .get(`${API}/sponsored`, { params: { placement } })
      .then((r) => live && setSlots(r.data.slots || []))
      .catch(() => live && setSlots([]));
    return () => {
      live = false;
    };
  }, [placement]);
  if (!slots.length) return null;
  return (
    <section className="mt-6 border border-black p-3" data-testid="sponsored-slots" aria-label="sponsored">
      <div className="text-[10px] font-bold uppercase tracking-wide text-[#666] mb-2">sponsored</div>
      <ul className="space-y-3">
        {slots.map((t) => (
          <li key={t.id} className="flex flex-wrap items-baseline gap-x-2 text-[13px]" data-testid={`sponsored-${t.slug}`}>
            <Link to={`/tool/${t.slug}`} className="tv-link font-bold">{t.title}</Link>
            {t.pricing && <span className="text-[#666]">— {t.pricing}</span>}
            <span className="w-full text-[#222]">{t.key_feature || t.description}</span>
            <a
              href={t.vendor?.cta_url || outboundHref(t, "sponsored")}
              target="_blank"
              rel="noopener noreferrer sponsored"
              onClick={() => recordLaunch(t.id)}
              className="tv-link text-[12px]"
              data-testid={`sponsored-visit-${t.slug}`}
            >
              [↗] {t.vendor?.cta_label || "visit"}
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
}
